import { BackstageOverrides } from '@backstage/core-components';
import { Theme } from '@mui/material/styles';
import { getSurfaceBorder, getSurfaceColor, getThemeTokens } from '../tokens';

export const styledMuiTableCell = (
  theme: Theme,
): BackstageOverrides['MuiTableCell'] => {
  const tokens = getThemeTokens(theme);

  return {
    root: {
      borderBottom: `1px solid ${getSurfaceBorder(theme)}`,
      color: tokens.textPrimary,
      padding: theme.spacing(1.75, 2.25),
    },
    head: {
      backgroundColor: getSurfaceColor(theme, 'subtle'),
      color: tokens.textPrimary,
      fontSize: theme.typography.caption.fontSize,
      fontWeight: 700,
      textTransform: 'uppercase',
      letterSpacing: '0.06em',
    },
    body: {
      backgroundColor: getSurfaceColor(theme, 'raised'),
    },
  };
};
